module.exports = __webpack_public_path__ + "img/Brock.7d006941.png";